import { type ProcessType } from '@frontend/api';

import { RootState } from 'store/configureStore';
import { ActionWithPayload } from 'store/types';

import { types } from './actions';

type ProcessSelectorState = {
  hasInitiated: boolean;
  isLoading: boolean;
  processes: ProcessType[];
};

const initialState: ProcessSelectorState = {
  hasInitiated: false,
  isLoading: false,
  processes: [],
};

type ProcessSelectorAction =
  | ActionWithPayload<typeof types.FETCH_PROCESSES_ERROR>
  | ActionWithPayload<
      typeof types.FETCH_PROCESSES_SUCCESS,
      { processes: ProcessType[] }
    >
  | ActionWithPayload<typeof types.FETCH_PROCESSES_REQUEST>;

const reducer = (
  state = initialState,
  action: ProcessSelectorAction,
): ProcessSelectorState => {
  switch (action.type) {
    case types.FETCH_PROCESSES_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case types.FETCH_PROCESSES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.FETCH_PROCESSES_SUCCESS:
      return {
        ...state,
        hasInitiated: true,
        isLoading: false,
        processes: action.payload.processes,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state: RootState): ProcessSelectorState =>
  state.modules.common.smartComponents.processSelector;

export const getHasInitiated = (state: RootState): boolean =>
  getScope(state).hasInitiated;

export const getIsLoading = (state: RootState): boolean =>
  getScope(state).isLoading;

export const getProcesses = (state: RootState): ProcessType[] =>
  getScope(state).processes;
